import React from 'react';
import { connect } from 'react-redux';
// import FontIcon from 'react-toolbox/lib/font_icon';
import { get } from '~/actions/bundles';
import Title from '~/components/Title';
import style from './style.scss';

class Bundle extends React.Component {
  static contextTypes = {
    dialogClose: React.PropTypes.func.isRequired,
    dialogPush: React.PropTypes.func.isRequired,
    apiClient: React.PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: true
    };
  }

  componentDidMount() {
    this.load();
  }

  load() {
    if (!this.props.id || !this.props.item) {
      this.setState({ loading: true });
      return;
    }

    get(this.props.dispatch, this.context.apiClient, this.props.id)
      .then(() => this.setState({ loading: false }))
      .catch(() => this.setState({ loading: false }));
  }

  renderItem() {
    const bundle = this.props.item.toJS();
    return (
      <div onClick={() => this.context.dialogPush('bundle', { id: bundle.id })}>
        <div>
          <div style={{ display: 'inline-block' }}>
            <Title>
              #{bundle.sku} - {bundle.name}
            </Title>
            UPC: {bundle.upc}
          </div>
        </div>
        {bundle.removed && <div className={style.removed}>REMOVED</div>}
      </div>
    );
  }

  render() {
    const { id, item, className, dispatch, articleCount, tasks, ...props } = this.props;
    return (
      <div className={[style.container, className].join(' ')} {...props}>
        <div className={style.content}>
          {this.state.loading && 'Loading'}
          {!this.state.loading && !item && '404'}
          {!this.state.loading && item && this.renderItem()}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  item: state.getIn(['bundles', 'items', props.id])
});

export default connect(mapStateToProps)(Bundle);



// WEBPACK FOOTER //
// ./app/components/Bundle/index.js